import React from "react";

import { useTravelDatesContext } from "../../../providers/travel-dates.provider";

export default function Title() {
  const { groupedMagnoliaData, keyForGroupedMagnolia } =
    useTravelDatesContext();
  const { title } =
    groupedMagnoliaData?.[keyForGroupedMagnolia]?.descriptionSection ?? {};

  return (
    <h2
      className={`
        md:!text-3xl font-header-font leading-[21px] 
        md:leading-[34.1px] text-[20px] md:mb-spacing-xs mb-spacing-m text-surface-neutral-option-1
      `}
    >
      {title}
    </h2>
  );
}
